import React from 'react';
import { Radio, FormControlLabel, Grid } from '@material-ui/core';
import { FormSection, SectionTitle, FormGrid, FieldLabel, CommunicationChannelContainer, StyledTextField, StyledRadioGroup, Icon, } from './styles';
import { useProviderServices } from 'src/hooks/useProviderServices';
import PhoneIcon from 'src/assets/Images/phone-call-01.svg';
import MailIcon from 'src/assets/Images/mail-01.svg';
import MessageIcon from 'src/assets/Images/message-text-circle-01.svg';
import UserIcon from 'src/assets/Images/user-02.svg';
import SearchableSelect from '../Common/SearchableSelect/SearchableSelect';
import { FormGridItem } from 'src/Views/CreateTicketPage/TicketForm/styles';
var communicationChannelOptions = [
    {
        value: 'phone',
        imgSrc: PhoneIcon,
        imgAlt: 'Phone',
        label: 'Teléfono',
    },
    {
        value: 'email',
        imgSrc: MailIcon,
        imgAlt: 'Mail',
        label: 'Mail',
    },
    {
        value: 'whatsapp',
        imgSrc: MessageIcon,
        imgAlt: 'WhatsApp',
        label: 'Whatsapp',
    },
    {
        value: 'in_person',
        imgSrc: UserIcon,
        imgAlt: 'In Person',
        label: 'Presencial',
    },
];
export var ServiceRequestSection = function (_a) {
    var formData = _a.formData, errors = _a.errors, onInputChange = _a.onInputChange, _b = _a.showCommunicationChannel, showCommunicationChannel = _b === void 0 ? true : _b;
    var _c = useProviderServices(), providerServices = _c.providerServices, loading = _c.loading, error = _c.error;
    return (React.createElement(FormGridItem, null,
        React.createElement(FormSection, null,
            React.createElement(SectionTitle, null, "Servicio solicitado"),
            React.createElement(FormGrid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 12, md: 6, className: "service-problem-field" },
                    React.createElement(FieldLabel, null, "Problema o Solicitud"),
                    React.createElement(StyledTextField, { size: "small", placeholder: "Problema o Solicitud", value: formData.title, onChange: function (e) { return onInputChange('title', e.target.value); }, error: !!errors.title, helperText: errors.title })),
                React.createElement(Grid, { item: true, xs: 12, md: 6 },
                    React.createElement(SearchableSelect, { clearable: true, label: "Tipo de servicio requerido", value: formData.provider_service, onChange: function (value) { return onInputChange('provider_service', value); }, options: providerServices, placeholder: loading ? 'Cargando servicios...' : 'Selecciona un servicio', error: errors.provider_service, disabled: loading, sortOptions: true })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FieldLabel, null, "Descripci\u00F3n del problema"),
                    React.createElement(StyledTextField, { multiline: true, rows: 4, placeholder: "Descripci\u00F3n del problema", value: formData.description, onChange: function (e) { return onInputChange('description', e.target.value); }, error: !!errors.description, helperText: errors.description })),
                showCommunicationChannel && (React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(CommunicationChannelContainer, null,
                        React.createElement(FieldLabel, null, "Canal de comunicaci\u00F3n"),
                        React.createElement(StyledRadioGroup, { row: true, value: formData.communication_channel, onChange: function (e) {
                                return onInputChange('communication_channel', e.target.value);
                            } }, communicationChannelOptions.map(function (option) { return (React.createElement(FormControlLabel, { key: option.value, value: option.value, control: React.createElement(Radio, null), label: React.createElement(Icon, null,
                                React.createElement("img", { src: option.imgSrc, alt: option.imgAlt, width: "16", height: "16" }),
                                option.label) })); })))))))));
};
export default ServiceRequestSection;
